import Flex from "components/grid/Flex";
import { Button } from "@material-ui/core";
import { useState } from "react";
import { FiltersByCategoryRenderer } from "./filter-components/FiltersByCategoryRenderer";
import { AddFilterModal } from "./filter-components/AddFilterModal";

export const FilterBuilder = ({ translate, formTree }) => {
    const [addCriteriaModalOpen, setAddCriteriaModalOpen] = useState(false);
    const closeModal = () => setAddCriteriaModalOpen(false);
    const openModal = () => setAddCriteriaModalOpen(true);

    return (
        <Flex item container style={{ paddingLeft: 34 }}>
            <div style={{ width: "100%" }}>
                <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                    <FiltersByCategoryRenderer formTree={formTree} />
                </div>
                <div>
                    <Button onClick={openModal} style={{ textTransform: "none" }}>
                        +&nbsp;{translate("cohort.add-criteria")}
                    </Button>
                    <AddFilterModal formTree={formTree} isOpen={addCriteriaModalOpen} onClose={closeModal} />
                </div>
            </div>
        </Flex>
    );
};
